module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/bottom_bgm-cbda4d6fad6891d980f971134d05642a.svg";